export default __webpack_public_path__ + "static/media/arrow_down_bold.2ef74f69.svg";